/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Scope_Members_InvalidInputs */

const fr_team_scope_members_invalid = /** @type {(inputs: Team_Scope_Members_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez des collaborateurs actifs de votre organisation.`)
};

const en_team_scope_members_invalid = /** @type {(inputs: Team_Scope_Members_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select active collaborators from your organization.`)
};

/**
* | output |
* | --- |
* | "Select active collaborators from your organization." |
*
* @param {Team_Scope_Members_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const team_scope_members_invalid = /** @type {((inputs?: Team_Scope_Members_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Scope_Members_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_scope_members_invalid(inputs)
	return fr_team_scope_members_invalid(inputs)
});